export const fetch_user_uploads = (id)  => 
    fetch(global.config.server_path+'folder/get', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id})})	
	.then(resp => resp.json())
    .then(resp => validate_response(resp))
	.catch(err => Promise.reject(err))

export const fetch_design_template = (id) => (dispatch) => {
	var url = global.config.server_path+'design/get_one/';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id})})
	.then(resp => (Promise.resolve(resp.json())))
    .then(resp => validate_response(resp))
	.catch(err => (Promise.reject(err)))
}

export const fetch_text_template = (id) => (dispatch) => {
	var url = global.config.server_path+'text_template/get_one/';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id})})
	.then(resp => (Promise.resolve(resp.json())))
    .then(resp => validate_response(resp))
	.catch(err => (Promise.reject(err)))
}

export const fetch_saved_design = (id) => (dispatch) => {
	var url = global.config.server_path+'saved_design/get_one/';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id})})
	.then(resp => resp.json())
    .then(resp => validate_response(resp))
	.catch(err => Promise.reject(err))
}

export const share_permission_with_emails = (host_email,emails,saved_design,role) => (dispatch) => {
	var url = global.config.server_path+'permission/share_permission_with_emails/';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({host_email,emails,saved_design,role})})
	.then(resp => (Promise.resolve(resp.json())))
    .then(resp => validate_response(resp))
	.catch(err => (Promise.reject(err)))
}

export const check_permission = (user_email,saved_design,role) => (dispatch) => {
	var url = global.config.server_path+'permission/check_permission/';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({user_email,saved_design,role})})
	.then(resp => (Promise.resolve(resp.json())))
    .then(resp => validate_response(resp))
	.catch(err => (Promise.reject(err)))
}


export const upload_user_file = (file, folder_id) => {
	var form_data = new FormData()
	form_data.append('file', file, file.name);
	form_data.append('folder_id', folder_id)
  	var url = global.config.server_path + 'folder/upload_file';
  	return fetch(url, {method: 'POST', 'credentials': 'include', body: form_data})
	  
};


export const create_order = (design_id, resources, coupon_code) => {
	var url = global.config.server_path+'order/add_design_order/';
	var data = {design_id, resources};
	if (coupon_code) {
		data = {...data, coupon_code};
	}
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify(data)})
	.then(resp => (Promise.resolve(resp.json())))
    .then(resp => validate_response(resp))
	.catch(err => (Promise.reject(err)))
}


export const confirm_order = (order_id,  payment_details)  => {
	var url = global.config.server_path+'order/confirm/';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({order_id,  payment_details, order_type: 'design'})})
	.then(resp => (Promise.resolve(resp.json())))
    .then(resp => validate_response(resp))
	.catch(err => (Promise.reject(err)))
}

export const set_elements_category = payload => ({type: 'SET_ELEMENTS_CATEGORY', payload});

var validate_response = (response) => response.response_code === 1 ? Promise.resolve(response) : Promise.reject(response)


export const update_design_name = (id, name) => {
	var url = global.config.server_path+'saved_design/update/';
	return fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id: id, name: name})})
	.then(resp => resp.json())
	.catch(err => Promise.reject(err))
};